webpackJsonp([102513572519481],{

/***/ 570:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.consultancyPageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var PropTypes = _interopRequireWildcard(_propTypes);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _Markdown = __webpack_require__(20);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _oogKlein = __webpack_require__(570);
	
	var _oogKlein2 = _interopRequireDefault(_oogKlein);
	
	var _indexModule = __webpack_require__(313);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  data: PropTypes.object.isRequired
	};
	
	var Consultancy = function (_React$Component) {
	  _inherits(Consultancy, _React$Component);
	
	  function Consultancy() {
	    _classCallCheck(this, Consultancy);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Consultancy.prototype.render = function render() {
	    var content = this.props.data.page.edges[0].node;
	    return _react2.default.createElement(
	      "div",
	      null,
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement(
	          "title",
	          null,
	          content.title
	        ),
	        _react2.default.createElement("meta", { name: "description", content: content.metaDescription }),
	        _react2.default.createElement("meta", { property: "og:title", content: content.title }),
	        _react2.default.createElement("meta", { property: "og:description", content: content.metaDescription })
	      ),
	      _react2.default.createElement(
	        "h1",
	        null,
	        content.title
	      ),
	      content.intro.intro && _react2.default.createElement(_Markdown2.default, { className: _indexModule2.default.intro, source: content.intro.intro }),
	      content.body.body && _react2.default.createElement(_Markdown2.default, { className: _indexModule2.default.article, source: content.body.body }),
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.contact },
	        _react2.default.createElement("img", { className: _indexModule2.default.oog, src: _oogKlein2.default, width: "50" }),
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.contactText },
	          _react2.default.createElement(
	            "div",
	            null,
	            "Interesse of een vraag?"
	          ),
	          _react2.default.createElement(
	            "div",
	            null,
	            "Neem dan contact met me op."
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _indexModule2.default.contactLink, to: "/contact" },
	          "Naar contact"
	        )
	      )
	    );
	  };
	
	  return Consultancy;
	}(_react2.default.Component);
	
	Consultancy.propTypes = propTypes;
	
	exports.default = Consultancy;
	var consultancyPageQuery = exports.consultancyPageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 313:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"intro":"src-pages-consultancy----index-module---intro---10nsP src-global-styles----content---intro---2xF3Y src-global-styles----content---textSerif---2B2hn src-global-styles----content---content---2NlNu src-global-styles----content---maxWidth---6eZ_6","article":"src-pages-consultancy----index-module---article---mn9Ld src-global-styles----content---textWide---2BLvj src-global-styles----content---content---2NlNu src-global-styles----content---maxWidth---6eZ_6","contact":"src-pages-consultancy----index-module---contact---rLgWK","oog":"src-pages-consultancy----index-module---oog---2CR9M","contactText":"src-pages-consultancy----index-module---contactText---1WthG src-global-styles----content---title---1yv3A","contactLink":"src-pages-consultancy----index-module---contactLink---2Jeyy src-global-styles----content---link---24uWM"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-consultancy-index-js-e3a192fae77564e153ba.js